import { render, staticRenderFns } from "./CargoStatusDetail.vue?vue&type=template&id=7157917b&"
import script from "./CargoStatusDetail.vue?vue&type=script&lang=js&"
export * from "./CargoStatusDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports